<div *ngIf="!embeddedMode" fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
  <h2 class="headline m-0" fxFlex="auto">
    <span class="text-primary mr-1">Compare {{dialog_title}}</span>
  </h2>
  <button type="button" (click)="dialogRef.close()" mat-icon-button class="text-secondary">
    <mat-icon [icIcon]="icClose"></mat-icon>
  </button>
</div>

<mat-divider *ngIf="!embeddedMode" class="-mx-6 text-border"></mat-divider>
<div class="overflow-auto" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-tab-group class="vex-tabs border-0" fxFlex="auto" [selectedIndex]="selectedIndex" (selectedIndexChange)="onSelectTab($event)">
      <mat-tab label="Summary">
        <div fxLayout="column" [ngStyle]="{'height': summaryHeight}">
          <div fxLayout="row" class="mt-4" fxFlex *ngIf="summaryLoader; else summaryContent">
            <div fxLayout="row" fxLayoutAlign="space-around start" fxFlex>
              <mat-progress-spinner strokeWidth="4" diameter="60" mode="indeterminate" color="primary"></mat-progress-spinner>
            </div>
          </div>
          <ng-template #summaryContent>
            <div fxLayout="row">
              <div fxFlex="50" class="border-r pr-4">
                <div fxLayout="column" fxLayoutGap.gt-sm="10px" class="mt-4">
                  <div fxFlex="row" fxLayoutAlign="start end">
                    <span class="primary leading-normal mr-1">
                      Service Name
                    </span>:
                    <span class="ml-1 text-sm leading-normal font-semibold text-black">
                      {{SourceInventory.Name}}
                    </span>
                    <span *ngIf="!embeddedMode" class="ml-1 label bg-purple-light text-purple">v {{SourceInventory.Version}}
                    </span>
                    <span *ngIf="!embeddedMode" class="label ml-1" style="opacity: 1;" fxFlex="none" [style.color]="SourceInventory.StateForeColor"
                      [style.background]="SourceInventory.StateColor">
                      {{SourceInventory.StateValue}}
                    </span>
                    <span *ngIf="!embeddedMode" class="label text-white ml-1" [ngClass]="CloudColor[SourceInventory.CloudName]">
                      {{SourceInventory.CloudName}}
                    </span>
                    <span *ngIf="!embeddedMode" class="label bg-teal-light text-teal ml-1">{{types[SourceInventory.InventoryType]}}</span>
                    <span class="label lbl-imported ml-1" *ngIf="SourceInventory.Imported && !embeddedMode" style="opacity: 1;" fxFlex="none">
                      Imported
                    </span>
                  </div>
                  <div fxFlex="row" *ngIf="!embeddedMode">
                    <span class="primary leading-normal">
                      {{isTemplate ? 'Template':'Blueprint'}}
                    </span>: 
                    <ng-container *ngIf="!isTemplate; else sourceTemplateName">
                      <span class="text-sm leading-normal font-semibold text-black text-primary underline cursor-pointer">
                        <a 
                          [routerLink]="['/network-management/blueprintdesigner/edit', SourceInventory.Blueprint.Id]"
                          target="_blank">
                          <span> {{SourceInventory.Blueprint.Name}}</span>
                          <button color="primary" type="button">
                            <ic-icon color="primary" [icon]="icExternalLink" class="mx-1" inline="true"
                              size="15px"></ic-icon>
                          </button>
                        </a>
                      </span>
                    </ng-container>
                    <ng-template #sourceTemplateName>
                        <span  class="text-sm leading-normal font-semibold text-black">{{ SourceInventory.Blueprint.Name }}</span>
                    </ng-template>
                    <span *ngIf="!embeddedMode" class="ml-1 small-label bg-purple-light text-purple">v {{SourceInventory.Blueprint.Version}}
                    </span>
                  </div>
                  <ng-container *ngIf="dialog_title == 'Instances' && !embeddedMode">
                    <div fxFlex="row">
                      <span class="primary leading-normal">
                      {{ usesAccountCredential(SourceInventory, SourceInventory.CloudName) ? 'Account Name' : 'Device Authentication'}}                    
                      </span>: 
                      <span class="flex-auto text-sm leading-normal font-semibold text-black">
                        {{SourceInventory.AccountName}}
                      </span>
                    </div>
                    <div fxFlex="row">
                      <span class="primary leading-normal">
                        Region
                      </span>: 
                      <span *ngIf="SourceInventory?.Regions?.length" class="flex-auto text-sm leading-normal font-semibold text-black">
                        {{SourceInventory.Regions.join(', ')}}
                      </span>
                      <span *ngIf="!SourceInventory?.Regions?.length" class="flex-auto text-sm leading-normal font-semibold text-black">
                        No Region Assigned
                      </span>
                    </div>
                  </ng-container>
                  <div fxFlex="row">
                    <span class="primary leading-normal">
                      Created Date
                    </span>: 
                    <span class="flex-auto text-sm leading-normal font-semibold text-black">
                      {{ (SourceInventory.UpdatedDate || SourceInventory.CreatedDate) 
                      ? (SourceInventory.UpdatedDate || SourceInventory.CreatedDate | dateFormat) 
                      : 'N/A' }}
                    </span>
                  </div>
                  <div fxFlex="row">
                    <span class="primary leading-normal">
                      Published Date
                    </span>: 
                    <span class="flex-auto text-sm leading-normal font-semibold text-black">
                      {{ (SourceInventory.UpdatedDate || SourceInventory.CreatedDate) 
                      ? (SourceInventory.UpdatedDate || SourceInventory.CreatedDate | dateFormat) 
                      : 'N/A' }}
                    </span>
                  </div>
                  <div fxFlex="row" *ngIf="!embeddedMode">
                    <span class="primary leading-normal">
                      Description
                    </span>: 
                    <span class="flex-auto text-sm leading-normal font-semibold text-black">
                      {{SourceInventory.Description || 'N/A'}}
                    </span>
                  </div>
                </div>
                <div class="card bg-app-bar mt-4" fxLayout="row">
                  <div fxLayout="column" fxLayoutGap="15px" fxFlex>
                    <div fxLayout="column" class="p-2">
                      <div class="border-b py-4" fxLayout="row" fxLayoutAlign="start center">
                        <h2 class="m-0 title text-primary">Resource Summary ({{TotalResourceSource}})</h2>
                      </div>
                      <div class="mt-2" gdColumns="1fr 1fr 1fr 1fr" gdColumns.lt-md="1fr 1fr" gdColumns.lt-sm="1fr"
                        gdGap="8px">
                        <div *ngFor="let resource of SourceSummary;trackBy:trackByListId" class="card overflow-hidden rounded-lg">
                          <div (click)="onClickResource(resource.Id, resource.Name)" class="p-4 text-center hover:bg-hover trans-ease-out cursor-pointer relative" matRipple>
                            <img  loading="lazy" decoding="async" [src]="resource.ImagePath" class="avatar h-16 w-16 mx-auto" (error)="getDefaultImage($event, SourceInventory.CloudName)">
                            <h2 class="title mb-1 mt-3">{{resource.Name}} <span><b>({{ resource.Count }})</b></span></h2>
                            <div class="body-2 text-secondary" *ngIf="resource.Name == 'Route Table'">
                              <span [ngClass]="{'text-warn': resource.IsDifference}">Routes ({{resource.SubCount}})</span>
                            </div>
                            <div class="body-2 text-secondary" *ngIf="resource.Name == 'NSG'">
                              <span [ngClass]="{'text-warn': resource.IsDifference}">Application Rules ({{resource.SubCount}})</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div fxFlex="50" class="border-l pl-4">
                <div fxLayout="column" fxLayoutGap.gt-sm="10px" class="mt-4">
                  <div fxFlex="row" fxLayoutAlign="start end">
                    <span class="mr-1 primary leading-normal">
                      Service Name
                    </span>:
                    <span class=" ml-1 text-sm leading-normal font-semibold text-black">
                      {{TargetInventory.Name}}
                    </span>
                    <span *ngIf="!embeddedMode" class="ml-1 label bg-purple-light text-purple">v {{TargetInventory.Version}}
                    </span>
                    <span *ngIf="!embeddedMode" class="label ml-1" style="opacity: 1;" fxFlex="none" [style.color]="TargetInventory.StateForeColor"
                      [style.background]="TargetInventory.StateColor">
                      {{TargetInventory.StateValue}}
                    </span>
                    <span *ngIf="!embeddedMode" class="label text-white ml-1" [ngClass]="CloudColor[TargetInventory.CloudName]">
                      {{TargetInventory.CloudName}}
                    </span>
                    <span *ngIf="!embeddedMode" class="label bg-teal-light text-teal ml-1">{{types[TargetInventory.InventoryType]}}</span>
                    <span class="label lbl-imported ml-1" *ngIf="TargetInventory.Imported && !embeddedMode" style="opacity: 1;" fxFlex="none">
                      Imported
                    </span>
                  </div>
                  <div fxFlex="row" *ngIf="!embeddedMode">
                    <span class="primary leading-normal">
                      {{isTemplate ? 'Template':'Blueprint'}}
                    </span>:
                    <ng-container *ngIf="!isTemplate; else targetTemplateName">
                      <span class="text-sm leading-normal font-semibold text-black text-primary underline cursor-pointer">
                          <a 
                            [routerLink]="['/network-management/blueprintdesigner/edit', TargetInventory.Blueprint.Id]"
                            target="_blank">
                            <span> {{TargetInventory.Blueprint.Name}}</span>
                            <button color="primary" type="button">
                              <ic-icon color="primary" [icon]="icExternalLink" class="mx-1" inline="true"
                                size="15px"></ic-icon>
                            </button>
                          </a> 
                      </span>
                    </ng-container>
                     <ng-template #targetTemplateName>
                        <span  class="text-sm leading-normal font-semibold text-black">{{ TargetInventory.Blueprint.Name }}</span>
                     </ng-template> 
                    <span *ngIf="!embeddedMode" class="ml-1 small-label bg-purple-light text-purple">v {{TargetInventory.Blueprint.Version}}
                    </span>
                  </div>
                  <ng-container *ngIf="dialog_title == 'Instances' && !embeddedMode">
                    <div fxFlex="row">
                      <span class="primary leading-normal">
                      {{ usesAccountCredential(TargetInventory, TargetInventory.CloudName) ? 'Account Name' : 'Device Authentication'}}   
                      </span>: 
                      <span class="flex-auto text-sm leading-normal font-semibold text-black">
                        {{TargetInventory.AccountName}}
                      </span>
                    </div>
                    <div fxFlex="row">
                      <span class="primary leading-normal">
                        Region
                      </span>: 
                      <span *ngIf="TargetInventory?.Regions?.length" class="flex-auto text-sm leading-normal font-semibold text-black">
                        {{TargetInventory.Regions.join(', ')}}
                      </span>
                      <span *ngIf="!TargetInventory.Regions?.length" class="flex-auto text-sm leading-normal font-semibold text-black">
                        No Region Assigned
                      </span>
                    </div>
                  </ng-container>
                  <div fxFlex="row">
                    <span class="primary leading-normal">
                      Created Date
                    </span>: 
                    <span class="flex-auto text-sm leading-normal font-semibold text-black">
                      {{ (TargetInventory.UpdatedDate || TargetInventory.CreatedDate) 
                      ? (TargetInventory.UpdatedDate || TargetInventory.CreatedDate | dateFormat) 
                      : 'N/A' }}
                    </span>
                  </div>
                  <div fxFlex="row">
                    <span class="primary leading-normal">
                      Published Date
                    </span>: 
                    <span class="flex-auto text-sm leading-normal font-semibold text-black">
                      {{ (TargetInventory.UpdatedDate || TargetInventory.CreatedDate) 
                      ? (TargetInventory.UpdatedDate || TargetInventory.CreatedDate | dateFormat) 
                      : 'N/A' }}
                    </span>
                  </div>
                  <div fxFlex="row" *ngIf="!embeddedMode">
                    <span class="primary leading-normal">
                      Description
                    </span>: 
                    <span class="flex-auto text-sm leading-normal font-semibold text-black">
                      {{TargetInventory.Description || 'N/A'}}
                    </span>
                  </div>
                </div>
                <div class="card bg-app-bar mt-4" fxLayout="row">
                  <div fxLayout="column" fxLayoutGap="15px" fxFlex>
                    <div fxLayout="column" class="p-2">
                      <div class="border-b py-4" fxLayout="row" fxLayoutAlign="start center">
                        <h2 class="m-0 title text-primary">Resource Summary ({{TotalResourceTarget}})</h2>
                      </div>
                      <div class="mt-2" gdColumns="1fr 1fr 1fr 1fr" gdColumns.lt-md="1fr 1fr" gdColumns.lt-sm="1fr"
                        gdGap="8px">
                        <div *ngFor="let resource of TargetSummary;trackBy:trackByListId" class="card overflow-hidden rounded-lg">
                          <div (click)="onClickResource(resource.Id, resource.Name)" class="p-4 text-center hover:bg-hover trans-ease-out cursor-pointer relative" matRipple>
                            <img loading="lazy" decoding="async" [src]="resource.ImagePath" class="avatar h-16 w-16 mx-auto" (error)="getDefaultImage($event, TargetInventory.CloudName)">
                            <h2 class="title mb-1 mt-3">{{resource.Name}} <span><b>({{ resource.Count }})</b></span></h2>
                            <div class="body-2 text-secondary" *ngIf="resource.Name == 'Route Table'">
                              <span [ngClass]="{'text-warn': resource.IsDifference}">Routes ({{resource.SubCount}})</span>
                            </div>
                            <div class="body-2 text-secondary" *ngIf="resource.Name == 'NSG'">
                              <span [ngClass]="{'text-warn': resource.IsDifference}">Application Rules ({{resource.SubCount}})</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </mat-tab>
      <mat-tab label="Tree View">
        <div fxLayout="column" *ngIf="isShowTreeView">
          <div fxLayout="row" class="mt-4" fxFlex *ngIf="summaryLoader; else treeContent">
            <div fxLayout="row" fxLayoutAlign="space-around start" fxFlex>
              <mat-progress-spinner strokeWidth="4" diameter="60" mode="indeterminate" color="primary"></mat-progress-spinner>
            </div>
          </div>
          <ng-template #treeContent>
            <div fxLayoutGap="20px" class="mt-4">
              <vex-multiple-selection-select-all fxFlex #MultipleSelectionSelectAllComponent
                [data]="filterAttribute"
                [form]="form"
                [selectionValues]="resources"
                [isShowRefreshButton]="false"
                [isShowCustomLabel]="false"
                (selectionChange)="filterTrees($event)"
              >
              </vex-multiple-selection-select-all>
              <mat-form-field fxFlex>
                <mat-label>Search by name</mat-label>
                <input type="text" [(ngModel)]="searchResource" matInput (input)="searchResources$.next()"/>
              </mat-form-field>
              <button type="button" style="height: 52px;" mat-raised-button color="primary"
                (click)="onReset()">
                <mat-icon [icIcon]="icClose" style="font-size: 25px;"></mat-icon>
              </button>
            </div>
            <div fxLayout="row">
              <div fxFlex="50" class="border-r pr-4">
                <div fxLayout="column">
                  <mat-card-subtitle class="ml-4">
                    <b>{{compareData.SourceName}}</b>
                    <div class="pill bg-purple-light text-purple ml-2">
                      v {{compareData.SourceVersion}}
                    </div>
                  </mat-card-subtitle>
                  <mat-card-subtitle class="ml-4">
                    <b>Last Updated Date</b>: {{compareData.SourceUpdatedDate || compareData.SourceCreatedDate | dateFormat}}
                  </mat-card-subtitle>
                  <div fxLayout="row" class="overflow-auto" [ngStyle]="{'height': treeHeight}">
                    <inventory-tree
                      *ngIf="SourceInventory.Blueprint.BlueprintContainers && SourceInventory.Blueprint.BlueprintContainers.length>0"
                      [isShowFilter]="false"
                      [isInventory]="true"
                      [showCSPFields]="true" [showAuditFields]="true" [showResourceStateLabel]="false" [defaultAudit]="getDefaultAudit(SourceInventory)" [isCheckbox]="false" [onlyMandatory]="false" [IsCollectionEntryAttributeId]="true"
                      [BlueprintContainers]="SourceInventory.Blueprint.BlueprintContainers">
                    </inventory-tree>
                  </div>
                </div>
              </div>
              <div fxFlex="50" class="border-l pl-4">
                <div fxLayout="column">
                  <mat-card-subtitle class="ml-4">
                    <b>{{compareData.TargetName}}</b>
                    <div class="pill bg-purple-light text-purple ml-2">
                      v {{compareData.TargetVersion}}
                    </div>
                  </mat-card-subtitle>
                  <mat-card-subtitle class="ml-4">
                    <b>Last Updated Date</b>: {{compareData.TargetUpdatedDate || compareData.TargetCreatedDate | dateFormat}}
                  </mat-card-subtitle>
                  <div fxLayout="row" class="overflow-auto" [ngStyle]="{'height': treeHeight}">
                    <inventory-tree
                      *ngIf="TargetInventory.Blueprint.BlueprintContainers && TargetInventory.Blueprint.BlueprintContainers.length>0"
                      [isShowFilter]="false"
                      [isInventory]="true"
                      [showCSPFields]="true" [showAuditFields]="true" [showResourceStateLabel]="false" [defaultAudit]="getDefaultAudit(TargetInventory)" [isCheckbox]="false" [onlyMandatory]="false" [IsCollectionEntryAttributeId]="true"
                      [BlueprintContainers]="TargetInventory.Blueprint.BlueprintContainers">
                    </inventory-tree>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </mat-tab>
      <mat-tab label="Configuration">
        <div fxLayout="column" [ngStyle]="{'height': configurationHeight}">
          <div class="pt-4" fxLayout="row" *ngIf="!loadEditor;">
            <div fxFlex="50">
              <div fxLayout="column">
                <mat-card-subtitle>
                  <b>{{compareData.SourceName}}</b>
                  <div *ngIf="!embeddedMode" class="pill bg-purple-light text-purple ml-2">
                    v {{compareData.SourceVersion}}
                  </div>
                </mat-card-subtitle>
                <mat-card-subtitle>
                  <b>Last Updated Date</b>: {{compareData.SourceUpdatedDate || compareData.SourceCreatedDate | dateFormat}}
                </mat-card-subtitle>
              </div>
            </div>
            <div fxFlex="50">
              <div fxLayout="column">
                <mat-card-subtitle>
                  <b>{{compareData.TargetName}}</b>
                  <div *ngIf="!embeddedMode" class="pill bg-purple-light text-purple ml-2">
                    v {{compareData.TargetVersion}}
                  </div>
                </mat-card-subtitle>
                <mat-card-subtitle>
                  <b>Last Updated Date</b>: {{compareData.TargetUpdatedDate || compareData.TargetCreatedDate | dateFormat}}
                </mat-card-subtitle>
              </div>
            </div>
          </div>
          <div fxLayout="column" class="mt-4" style="height: 100%" *ngIf="configurationLoader">
            <div fxLayout="row" class="mb-4">
              <mat-slide-toggle fxLayoutAlign="end end" fxFlex color="primary" (change)="onToggleChange($event)">
                <span class="">Seprate Scroll</span>
              </mat-slide-toggle>
            </div>
            <div class="overflow-y-auto" fxFlex="auto">
              <ng-container *ngIf="isEditorShowSeprate; else diff">
                <div fxLayout="row" fxFlex="100">
                  <div fxFlex="50">
                    <ngx-monaco-editor style="height: 100%" 
                      [options]="editorOptions"
                      [(ngModel)]="compareData.SourceCode"
                      (init)="editorInit($event)"
                    >
                    </ngx-monaco-editor>
                  </div>
                  <div fxFlex="50">
                    <ngx-monaco-editor style="height: 100%" 
                      [options]="editorOptions"
                      [(ngModel)]="compareData.TargetCode"
                      (init)="editorInit($event)"
                    >
                    </ngx-monaco-editor>
                  </div>
                </div>
              </ng-container>
              <ng-template #diff>
                <ngx-monaco-diff-editor fxFlex
                  [options]="editorOptions" 
                  [original]="compareData.SourceCode" 
                  [modified]="compareData.TargetCode" 
                  (init)="editorInit($event)"
                  style="height: 100%" 
                ></ngx-monaco-diff-editor>
              </ng-template>
            </div>
          </div>
          <div fxLayout="row" class="mt-4" fxFlex *ngIf="loadEditor;">
            <div fxLayout="row" fxLayoutAlign="space-around start" fxFlex>
              <mat-progress-spinner strokeWidth="4" diameter="60" mode="indeterminate" color="primary"></mat-progress-spinner>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Associated Configuration" *ngIf="showAssociatedConfigurationTab()">
        <div fxLayout="column" class="associated-tab-content" [ngStyle]="{'height': associatedConfigurationHeight}">
          <div *ngIf="associatedConfigurationLoading || !associatedConfigurationLoaded" fxLayout="column" fxLayoutAlign="center center" class="associated-loading-state">
            <mat-progress-spinner strokeWidth="4" diameter="40" mode="indeterminate" color="primary"></mat-progress-spinner>
            <div class="text-secondary mt-3">Checking for associated configuration...</div>
          </div>
          <mat-accordion *ngIf="associatedConfigurationLoaded && !associatedConfigurationLoading && hasAssociatedConfigurationComparisons(); else noAssociatedConfig" class="associated-comparison-accordion">
            <mat-expansion-panel
              *ngFor="let comparison of associatedConfigurationComparisons; let i = index;trackBy:trackByListId"
              [expanded]="i === 0"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>{{ comparison.title }}</mat-panel-title>
                <mat-panel-description>Associated template configuration</mat-panel-description>
              </mat-expansion-panel-header>
              <ng-container *ngIf="canCompareAssociatedInventories(comparison); else notEnoughAssociatedConfig">
                <ng-container
                  *ngComponentOutlet="
                    associatedInventoryComparisonComponent;
                    injector: getAssociatedInventoryComparisonInjector(comparison)
                  "
                ></ng-container>
              </ng-container>
              <ng-template #notEnoughAssociatedConfig>
                <div fxLayout="row" fxLayoutGap="16px" class="associated-comparison-summary">
                  <div fxFlex>
                    <b>{{ comparison.sourceLabel }}</b>
                    <div class="text-secondary">{{ comparison.sourceMeta }}</div>
                  </div>
                  <div fxFlex>
                    <b>{{ comparison.targetLabel }}</b>
                    <div class="text-secondary">{{ comparison.targetMeta }}</div>
                  </div>
                </div>
                <ngx-monaco-diff-editor
                  class="associated-diff-editor"
                  [options]="editorOptions"
                  [original]="comparison.sourceCode"
                  [modified]="comparison.targetCode"
                ></ngx-monaco-diff-editor>
              </ng-template>
            </mat-expansion-panel>
          </mat-accordion>
          <ng-template #noAssociatedConfig>
            <blockquote *ngIf="associatedConfigurationLoaded && !associatedConfigurationLoading">No associated configuration is available for these versions.</blockquote>
          </ng-template>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
